// STYLES AND BLOCKS
import "../styles/styles.css";
import "./common.js";

// LIBRARIES
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// ANIMATIONS

gsap.registerPlugin(ScrollTrigger);	
gsap.set(".reveal", { autoAlpha: 0, y: 20 });

ScrollTrigger.batch(".reveal", {
    start: "top 85%",
    once: true,
    onEnter: (els) =>
    gsap.to(els, { autoAlpha: 1, y: 0, duration: 0.8, ease: "power2.out", stagger: 0.1 }),
});


document.querySelector('#menu-trigger').addEventListener('click', (ev) => {
    document.querySelector('#nav-main').classList.add('active');
    document.querySelector('body').classList.add('nav-active');
});

function closeMenu() {
    document.querySelector('#nav-main').classList.remove('active');
    document.querySelector('body').classList.remove('nav-active');
}

document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
        closeMenu();
    }
});

document.querySelector('#nav-main .close').addEventListener('click', (ev) => {
    closeMenu();
});

document.querySelector('#nav-overlay').addEventListener('click', (ev) => {
    closeMenu();
});

